export default "assets/images/logo-lion-9456fa09.svg";